import { makeStyles, Popover, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: "3px",
  },
}));

type PopoverProps = {
  title: string;
  handlePopoverClose: () => void;
  open: boolean;
  anchorEl: any;
};

const SimplePopover = ({
  title,
  handlePopoverClose,
  open,
  anchorEl,
}: PopoverProps) => {
  const classes = useStyles();
  return (
    <>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography>{title}</Typography>
      </Popover>
    </>
  );
};

export default SimplePopover;
